import axios from 'axios';
import REACT_APP_BACK_URL from '../../constants/constants';

export const getMembers = async ({
  workspaceName, page, pageSize, search = '',
}) => axios.get(`${REACT_APP_BACK_URL}/${workspaceName}/members?page=${page}&pageSize=${pageSize}&search=${search}`);

export const getMember = async ({ workspaceName, username }) => axios.get(`${REACT_APP_BACK_URL}/${workspaceName}/members/${encodeURIComponent(username)}`);

export const updateMemberRole = async ({ workspaceName, username, roleName }) => axios.patch(`${REACT_APP_BACK_URL}/${workspaceName}/members/${encodeURIComponent(username)}`, { roleName });

export const deleteMembers = async ({ workspaceName, ids }) => axios.delete(`${REACT_APP_BACK_URL}/${workspaceName}/members`, { data: ids });

export const createInvitation = async ({ workspaceName, roleName }) => axios.post(`${REACT_APP_BACK_URL}/${workspaceName}/invitations`, { roleName });

export const getTeams = async ({
  workspaceName, page, pageSize, search = '',
}) => axios.get(`${REACT_APP_BACK_URL}/${workspaceName}/teams?page=${page}&pageSize=${pageSize}&search=${search}`);

export const getTeam = async ({ workspaceName, teamName }) => axios.get(`${REACT_APP_BACK_URL}/${workspaceName}/teams/${encodeURIComponent(teamName)}`);

export const createTeam = async ({ workspaceName, name, description }) => axios.post(`${REACT_APP_BACK_URL}/${workspaceName}/teams`, { name, description });

export const updateTeam = async ({
  workspaceName, teamId, name, description,
}) => axios.patch(`${REACT_APP_BACK_URL}/${workspaceName}/teams/${teamId}`, { name, description });

export const deleteTeams = async ({ workspaceName, ids }) => axios.delete(`${REACT_APP_BACK_URL}/${workspaceName}/teams`, { data: ids });

export const addTeamMember = async ({ workspaceName, teamId, userId }) => axios.post(`${REACT_APP_BACK_URL}/${workspaceName}/teams/${teamId}/members`, { userId });

export const removeTeamMember = async ({ workspaceName, teamId, userId }) => axios.delete(`${REACT_APP_BACK_URL}/${workspaceName}/teams/${teamId}/members/${userId}`);

export const addTeamProject = async ({ workspaceName, teamId, projectId }) => axios.post(`${REACT_APP_BACK_URL}/${workspaceName}/teams/${teamId}/projects`, { projectId });

export const removeTeamProject = async ({ workspaceName, teamId, projectId }) => axios.delete(`${REACT_APP_BACK_URL}/${workspaceName}/teams/${teamId}/projects/${projectId}`);

export const getRoles = async ({
  workspaceName, page, pageSize, search = '',
}) => axios.get(`${REACT_APP_BACK_URL}/${workspaceName}/roles?page=${page}&pageSize=${pageSize}&search=${search}`);

export const getRole = async ({ workspaceName, roleName }) => axios.get(`${REACT_APP_BACK_URL}/${workspaceName}/roles/${encodeURIComponent(roleName)}`);

export const createRole = async ({ workspaceName, name, description }) => axios.post(`${REACT_APP_BACK_URL}/${workspaceName}/roles`, { name, description });

export const updateRole = async ({
  workspaceName, roleId, name, description,
}) => axios.patch(`${REACT_APP_BACK_URL}/${workspaceName}/roles/${roleId}`, { name, description });

export const deleteRoles = async ({ workspaceName, ids }) => axios.delete(`${REACT_APP_BACK_URL}/${workspaceName}/roles`, { data: ids });

export const getPermissions = async ({ workspaceName }) => axios.get(`${REACT_APP_BACK_URL}/${workspaceName}/permissions`);

export const addPermissionToRole = async ({ workspaceName, roleId, permissionId }) => axios.post(`${REACT_APP_BACK_URL}/${workspaceName}/roles/${roleId}/permissions`, { permissionId });

export const removePermissionFromRole = async ({ workspaceName, roleId, permissionId }) => axios.delete(`${REACT_APP_BACK_URL}/${workspaceName}/roles/${roleId}/permissions/${permissionId}`);
